import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import InboxPage from "../components/InboxPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const InboxPageContainer = connect(mapStateToProps, mapDispatchToProps)(InboxPage);

export default InboxPageContainer;


// WEBPACK FOOTER //
// ./src/containers/InboxPageContainer.js